import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#4A148C', // Deep Purple - Wisdom, Dignity
            light: '#7C43BD',
            dark: '#12005E',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#FFC107', // Warm Gold - Learning, Energy
            light: '#FFECB3',
            dark: '#FFA000',
            contrastText: '#000000',
        },
        background: {
            default: '#FAFAFA',
            paper: '#FFFFFF',
            subtle: '#F3E5F5', // Light Purple shade
        },
        text: {
            primary: '#212121',
            secondary: '#616161',
        },
        info: {
            main: '#009688', // Teal accent from logo
        }
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 800,
            letterSpacing: '-0.02em',
        },
        h2: {
            fontWeight: 700,
            letterSpacing: '-0.01em',
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 8,
        },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    padding: '10px 24px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0 4px 12px rgba(74, 20, 140, 0.2)', // Purple shadow
                    },
                },
                containedPrimary: {
                    background: 'linear-gradient(45deg, #4A148C 30%, #7C43BD 90%)',
                }
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                },
            },
        },
    },
});

export default theme;
